<template>
  <div>
    <label v-if="label" class="inputLabel">
      {{ label }}
      <span v-if="required" class="requiredStar">*</span>
    </label>
    <div
      class="file-input"
      :class="{
        'file-input--uploaded': existingImg,
        'file-input--focus': isFocused,
      }"
    >
      <div
        class="file-input__area ta-center p-md"
        :class="required && error ? 'fileError' : ''"
        v-show="!existingImg"
        style="margin-top: 0.33em;"
      >
        <input
          type="file"
          ref="fileUpload"
          :multiple="multiple"
          :name="fieldName"
          :disabled="isDisabled"
          @change="changeFiles($event.target)"
          :accept="accept"
        />
        <label
          style="display: flex; flex-direction: column; align-items: center;"
          for="file"
        >
          <svg
            style="margin-bottom: 0.75rem;"
            width="64"
            height="48"
            viewBox="0 0 64 48"
            fill="#e0e0e0;"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M58 48C59.625 48 61 47.5 62.25 46.25C63.375 45.125 64 43.75 64 42V6C64 4.375 63.375 3 62.25 1.75C61 0.625 59.625 0 58 0H6C4.25 0 2.875 0.625 1.75 1.75C0.5 3 0 4.375 0 6V42C0 43.75 0.5 45.125 1.75 46.25C2.875 47.5 4.25 48 6 48H58ZM14 7C15.875 7 17.5 7.75 18.875 9.125C20.25 10.5 21 12.125 21 14C21 16 20.25 17.625 18.875 19C17.5 20.375 15.875 21 14 21C12 21 10.375 20.375 9 19C7.625 17.625 7 16 7 14C7 12.125 7.625 10.5 9 9.125C10.375 7.75 12 7 14 7ZM8 40V34L17 25C17.25 24.75 17.5 24.625 18 24.625C18.375 24.625 18.75 24.75 19 25L26 32L43 15C43.25 14.75 43.5 14.625 44 14.625C44.375 14.625 44.75 14.75 45 15L56 26V40H8Z"
              fill="#E0E0E0"
            />
          </svg>

          <p
            v-if="!fileName"
            class="fc-medium fs-sm"
            style="font-weight: 600; color: #727a88; margin-bottom: 1rem;"
          >
            {{ zoneText }}
          </p>
          <div v-html="uploadDescription" style="max-width: 350px;"></div>
        </label>
      </div>
      <div class="file-input__area ta-center p-md" v-show="existingImg">
        <img
          v-if="!isPDF"
          class="file-input__image"
          :class="{ 'is-visible': existingImg }"
          :src="existingImg"
          alt=""
          style="max-height: 160px;"
        />
        <div v-if="isPDF || isBlob" class="frame-wrapper" style="">
          <iframe class="frame" :width="'100%'" :src="existingImg" />
        </div>
        <Button
          bMargin="top"
          :bType="buttonType !== '' ? buttonType : 'error'"
          :class="{ 'is-visible': existingImg }"
          type="button"
          name="deleteLogo"
          v-on:button-click="deleteFile()"
        >
          {{ buttonText }}
        </Button>
      </div>
      <p class="file-input__help fc-medium fs-sm mt-xxs" v-if="!existingImg">
        {{ helpText }}
      </p>
      <!-- <div
        v-if="error"
        class="flex items-center pointer-events-none"
        style="margin-top: 8px;"
      >
        <svg class="h-5 w-5 text-red-medium" fill="#ff5252" viewBox="0 0 20 20">
          <path
            fill-rule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
            clip-rule="evenodd"
          />
        </svg>
        <p class="inputErrorText">
          {{ error }}
        </p>
      </div> -->
    </div>
  </div>
</template>

<script>
import Button from '@/components/DesignSystem/Button';

export default {
  name: 'fileUploadZone',
  props: {
    accept: {
      type: String,
      default: '',
    },
    field: {
      type: String,
      default: 'image',
    },
    existingImg: {
      type: String || undefined,
      default: '',
    },
    helpText: {
      type: String,
      default: '',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    fieldName: {
      type: String,
      default: '',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    zoneText: {
      type: String,
      default: 'Click or drag here to upload',
    },
    label: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      default: 'Delete image',
    },
    forceUpload: {
      type: Boolean,
      default: false,
    },
    uploadDescription: {
      type: String,
      default: '',
    },
    buttonType: {
      type: String,
      default: '',
    },

    // In bytes
    maxSize: {
      type: Number,
      default: 4000000,
    },
  },
  components: {
    Button,
  },
  computed: {
    isPDF() {
      if (
        this.existingImg.slice(0, 15) === 'data:image/jpeg' ||
        this.existingImg.slice(0, 14) === 'data:image/png'
      ) {
        return false;
      }

      const pdfSearch = this.existingImg.search('.pdf');

      if (pdfSearch > 500) {
        return false;
      }

      if (
        pdfSearch !== -1 ||
        this.existingImg.slice(0, 20) === 'data:application/pdf'
      ) {
        return true;
      }
      return false;
    },
    isBlob() {
      if (this.existingImg.slice(0, 4) === 'blob') {
        return true;
      }
      return false;
    },
  },
  data() {
    return {
      isFocused: false,
      fileCount: 0,
      fileName: undefined,
      error: false,
    };
  },
  methods: {
    changeFiles(target) {
      this.isFocused = true;
      this.fileCount = target.files.length;

      if (target.files[0].size >= this.maxSize) {
        this.error = `Please upload a file less than ${
          this.maxSize.toString()[0]
        }MB`;
        return this.deleteFile();
      }

      if (target.files[0].type === 'image/svg+xml') {
        this.error =
          'The file type you are attempting to upload is not supported.';
        return this.deleteFile();
      }

      this.error = false;

      if (this.fileCount) {
        this.fileName = Array.from(target.files)
          .map(file => file.name)
          .join(', ');
      }
      this.$emit('update-image', { file: target.files, field: this.field });
      this.$emit('error-change', false);
    },
    deleteFile() {
      this.fileCount = 0;
      this.fileName = '';
      this.isFocused = false;
      this.$emit('update-image', { file: undefined, field: this.field });
      if (this.required) {
        this.error = 'Please upload a file';
        this.$emit('error-change', true);
      }

      if (this.forceUpload) {
        setTimeout(() => {
          this.$refs.fileUpload.click();
        }, 200);
      }
    },
  },
  watch: {
    existingImg() {
      if (this.existingImg) {
        this.isFocused = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.file-input {
  background-color: #fff;
  margin-top: 0.25rem;

  .file-input__area {
    border: 1px dashed #abb0b6;
    padding: 1.5rem;
    cursor: pointer;
  }
}
.fa-picture-o {
  font-size: 7em;
  color: #e0e0e0;
}

p.fc-medium.fs-sm {
  max-width: 275px;
  margin: 0 auto;
}

.requiredStar {
  font-size: 14px;
  color: #ff5252;
  font-weight: 400;
  line-height: 24px;
}

.fileError {
  border-color: #ff5252 !important;
  background: #fff4f4;
}

.frame-wrapper {
  display: flex;
  justify-content: center;
  height: 250px;
}

.button {
  font-weight: 500;
  padding: 8px 16px;
  min-width: 32px;
  font-size: 14px;
  line-height: 20px;
  &.button-type-primary {
    margin-left: 8px;
    background: #7c5bc2;
    &:hover {
      background: #5b37a8;
    }
  }
  &.button-type-ghost {
    color: #202223;
    border: 1px solid #abb0b6;
    &:hover {
      background: #f6f6f7;
      border: 1px solid #a0a0a0;
    }
  }
}
</style>
